// Import and register all your controllers from the importmap under controllers/*

import { Application } from "stimulus"

const application = Application.start()
// TODO, FIX the two line below
//  Eager load all controllers defined in the import map under controllers/**/*_controller
import { registerControllers } from "stimulus-vite-helpers"
const controllers = import.meta.glob('./*_controller.js', { eager: true })

application.debug = false
window.Stimulus   = application

//// OLD without vite
registerControllers(application, controllers)
// Lazy load controllers as they appear in the DOM (remember not to preload controllers in import map!)
// import { lazyLoadControllersFrom } from "@hotwired/stimulus-loading"
// lazyLoadControllersFrom("controllers", application)
